var map = {
	"./Classic.jpg": "f3c8",
	"./Classic/Classic.jpg": "127c",
	"./Edelstahl.jpg": "c3a7",
	"./Edelstahl/Edelstahl.jpg": "fc2b",
	"./Frühling.jpg": "1cb6",
	"./Frühling/Frühling.jpg": "3a11",
	"./Karibik.jpg": "e14b",
	"./Karibik/Karibik.jpg": "4828",
	"./Kristall.jpg": "217c",
	"./Kristall/Kristall.jpg": "634c",
	"./London.jpg": "c0c2",
	"./London/London.jpg": "d80d",
	"./Standard.jpg": "20b9",
	"./Standard/Standard.jpg": "651b",
	"./Wien junior.jpg": "2921",
	"./Wien.jpg": "4e99",
	"./Wien/Wien.jpg": "2079",
	"./WienJunior/Wien junior.jpg": "2134"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5d77";